export * from './permissions-context-manager-tool.component';



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/tool/tools/permissions-context-manager-tool/index.ts